import { css } from '@emotion/css'
import { spacing, breakpoint, fontWeight, fontSize, mediaQueryHelper, shorthandHelper, textStyles } from '@offerzen/pinata'

const styles = {
  workInTech: css({
    marginTop: spacing.default,
    [mediaQueryHelper(breakpoint.phone)]: {
      margin: shorthandHelper([0, 0, 0, spacing.default]),
    },

    // Override base styles
    label: {
      marginBottom: 0,
    },
  }),

  notification: css({
    marginTop: spacing.default,

    p: {
      margin: 0,
    },
  }),

  field: css({
    width: '100%',
  }),

  formLabel: css({
    ':not(:first-child)': {
      marginTop: spacing.default,
    },
  }),

  primaryRole: css({
    gridColumn: '1 / 2',
  }),

  primaryRoleLabel: css({
    marginTop: spacing.default,
  }),

  otherArea: css({
    width: '100%',
  }),

  otherRole: css({
    width: '100%',

    // Override base styles
    input: {
      border: 'none',
      height: '100%',
    },
  }),

  text: css(textStyles),

  errorNotification: css({
    marginTop: spacing.medium,
  }),

  workType: css({
    marginTop: spacing.default,
    div: {
      display: 'flex',
      flexDirection: 'column',
    },
  }),

  fieldSet: css({
    marginBottom: spacing.large,

    '> legend': {
      fontWeight: fontWeight.medium,
      fontSize: fontSize.medium,
      marginBottom: spacing.medium,
    },
  }),
}

export default styles
